<div class="row">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row" *ngIf="sinceLastLogin != undefined">
            <div class="col-12">
                <div class="alert lastLogin" role="alert">
                    <div style="float:left; width:100%">
                        <a (click)="loadSinceLastVisit();" class="click">
                            <li>{{ 'pages.updates.vulnerabilities.sinceLastVisitPre' | translate }} {{sinceLastLogin}} {{ 'pages.updates.vulnerabilities.sinceLastVisitPost' | translate }} </li>
                        </a>
                    </div>
               </div>
            </div>
        </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>


<div class="row pb-3">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-body">
                        <div class="card-title justify-content-right">
                            <h6>
                                <div class="custom-control custom-switch right mr-3" style="float:left">
                                    <input type="checkbox" class="custom-control-input" id="advanceSearch" [(ngModel)]="advSearch">
                                    <label class="custom-control-label" for="advanceSearch">{{ 'pages.generic.advancedSearch' | translate }} </label>
                                </div>
                                <div class="custom-control custom-switch right" style="float:left">
                                    <input type="checkbox" class="custom-control-input" id="hideSaveSearch" [(ngModel)]="hideSaveSearch">
                                    <label class="custom-control-label" for="hideSaveSearch">{{ 'pages.generic.savedSearches' | translate }}</label>
                                </div>
                            </h6>
                        </div>
                        <form>

                            <div class="form-row">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="cve">{{ 'pages.updates.vulnerabilities.fieldTitles.cve' | translate }} </label>
                                    <input type="text" class="form-control" name="cve" aria-describedby="CVE" placeholder="CVE-" [(ngModel)]="cve">
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="vendor">{{ 'pages.updates.vulnerabilities.fieldTitles.vendor' | translate }}</label>
                                    <!-- <input type="text" class="form-control" name="vendor" aria-describedby="vendor" [(ngModel)]="vendor"> -->
                                    <input id="typeahead-basic" type="text" class="form-control" name="vendor" aria-describedby="vendor" [editable]="false" [placeholder]="'pages.generic.typeahead' | translate" [(ngModel)]="vendor" [ngbTypeahead]="vendorTA"/>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    
                                    <div class="row">
                                        <div class="col-10">
                                            <label for="product">{{ 'pages.updates.vulnerabilities.fieldTitles.product' | translate }}</label>
                                            <!-- <input type="text" class="form-control" name="product" aria-describedby="product" [(ngModel)]="product"> -->
                                            <input id="typeahead-basic" type="text" class="form-control" name="product" aria-describedby="product" [editable]="false" [placeholder]="'pages.generic.typeahead' | translate" [(ngModel)]="product" [ngbTypeahead]="productTA"/>
                                        </div>
                                        <div class="col-2 p-0">
                                            <label for="product">&nbsp;</label>
                                            <button class="btn btn-primary" *ngIf="product" (click)="watch(product, false);">Watch</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div [ngbCollapse]="!advSearch" id="advSearch">
                                <div class="form-row">
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="description">{{ 'pages.updates.vulnerabilities.fieldTitles.description' | translate }}</label>
                                        <input type="text" class="form-control" name="description" aria-describedby="description" [(ngModel)]="description">
                                    </div> 
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="severity">{{ 'pages.updates.vulnerabilities.fieldTitles.severity' | translate }}</label>
                                        <select class="form-control" name="severity" aria-describedby="severity" [(ngModel)]="severity">
                                            <option></option>
                                            <option value="NONE">None</option>
                                            <option value="LOW">Low</option>
                                            <option value="MEDIUM">Medium</option>
                                            <option value="HIGH">High</option>
                                            <option value="CRITICAL">Critical</option>
                                        </select>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="cpe">{{ 'pages.updates.vulnerabilities.fieldTitles.cpe' | translate }}</label>
                                        <input type="text" class="form-control" name="cpe" aria-describedby="cpe" [(ngModel)]="cpe">
                                    </div>
                                    <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="dateFrom">{{ 'pages.generic.dateFromTo' | translate }}</label>
                                        <div class="row">
                                            <div class="col-6" style="padding-right: 0;">
                                                <input type="date" class="form-control" name="dateFrom" aria-describedby="dateFrom" [(ngModel)]="dateFrom">
                                            </div>
                                            <div class="col-6" style="padding-left: 0;">
                                                <input type="date" class="form-control" name="dateTo" aria-describedby="dateTo" [(ngModel)]="dateTo">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="sort">{{ 'pages.generic.sort' | translate }}</label>
                                        <div class="row">
                                            <div class="col-8" style="padding-right: 0;">
                                                <select class="form-control" style="float:left;" name="sort" aria-describedby="sort" [(ngModel)]="sort">
                                                    <option></option>
                                                    <option value="publishedDate">Published</option>
                                                    <option value="lastModifiedDate">Last modified</option>
                                                    <option value="baseSeverity">Severity</option>
                                                    <option value="baseScore">Score</option>
                                                    <option value="impactScore">Impact</option>
                                                    <option value="exploitabilityScore">Exploitability</option>
                                                </select>
                                            </div>
                                            <div class="col-4" style="padding-left: 0;">
                                                <select class="form-control" name="sortOrder" aria-describedby="sortOrder" [(ngModel)]="sortOrder">
                                                    <option></option>
                                                    <option value="-1">DESC</option>
                                                    <option value="1">ASC</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <button class="btn btn-primary" (click)="search();">{{ 'pages.generic.filter' | translate }}</button>
                            <button class="btn btn-primary" (click)="reset();">{{ 'pages.generic.reset' | translate }}</button>
                            <button class="btn btn-primary" (click)="openSearchModal(saveSearch)" *ngIf="searched">{{ 'pages.generic.saveSearch' | translate }}</button> 
                        </form>

                    </div>
                </div>
                
            </div>
        </div>

        <div class="row pt-1" *ngIf="savedSearches && savedSearches.length > 0" [ngbCollapse]="!hideSaveSearch" id="savedSearch">
            <div class="col-12">
                <div class="card">
                    <div class="card-body p-1">
                        <span style="float:left" *ngFor="let search of savedSearches">
                            <button class="btn btn-primary" (click)="loadSearch(search);">{{search.name}}  <fa-icon [icon]="['fas', 'trash']" class="pl-2" (click)="deleteSearch($event, confirmDeleteSearch, search)"></fa-icon></button>
                        </span>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>


<div class="row rowfiller">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row pt-1">
            <div class="col-12 justify-content-right">

                <fa-icon [icon]="['fas', 'th-list']" size="2x" class="p-1 click" (click)="changeViewType('list')"></fa-icon>
                <fa-icon [icon]="['fas', 'th-large']" size="2x" class="p-1 click" (click)="changeViewType('grid')"></fa-icon>

            </div>
        </div>

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'vulns' }" (click)="page = 'vulns'; latestVulns();">{{ 'pages.updates.vulnerabilities.vulns' | translate }}</a>
            </li> 
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'watched' }" (click)="loadWatched();" >{{ 'pages.updates.vulnerabilities.watched' | translate }} <span class="badge badge-primary ml-2" style="padding:0.1rem 0.5rem;" *ngIf="watchedProducts">{{watchedProducts.length}}</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'flagged' }" (click)="loadFlagged();" >{{ 'pages.generic.flagged' | translate }} <span class="badge badge-primary ml-2" style="padding:0.1rem 0.5rem;" *ngIf="flagRefs">{{flagRefs.length}}</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'analytics' }" (click)="page = 'analytics';  latestVulns(); loadAnalytics();">{{ 'pages.generic.analytics' | translate }}</a>
            </li>
        </ul>

        <div class="row p-5 justify-content-center p-5" *ngIf="!analyticsDataLoaded && page === 'analytics'">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
            </div>
        </div>

        <div class="pt-3" *ngIf="analyticsDataLoaded && page === 'analytics'">

            <h2> {{ 'pages.generic.thisWeek' | translate }} </h2>

            <div class="row p-1">
                <div class="col-12">

                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="wordChartOptions"
                        [(update)]="updateWordChart"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>
            </div>

            <h2> {{ 'pages.generic.lastYear' | translate }} </h2>

            <div class="row p-1 status-table">
                <div class="col-xl-4 col-lg-4 col-sm-12 item first-col-status">
                    <h4> {{ 'pages.generic.atAGlance' | translate }} </h4> 
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                            <span>{{lastUpdated | date: 'dd/MM/yyyy'}}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.generic.lastUpdated' | translate }}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                            <h2 class="card-title">{{totalVulnerabilities}}</h2>
                            <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.vulnerabilities.totalVulns' | translate }}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                            <h2 class="card-title">
                                <span>{{totalVendors}}</span>
                            </h2>
                            <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.vulnerabilities.totalVends' | translate }}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                            <span>{{totalProducts}}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.vulnerabilities.totalProds' | translate }}</h6>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row pt-2">
                <div class="col-12">

                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="urgPieChartOptions"
                        [(update)]="updateUrgencyPie"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>
            </div>

            <div class="row pt-2">
                <div class="col-12" *ngIf="loadStackedBarSeverity">

                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="stackedBarSeverityOptions"
                        [(update)]="updateStackedBarSeverity"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>

            </div>

        </div>

        <div class="card-body p-t-1 p-3" *ngIf="page === 'watched'">
            <span *ngFor="let prod of watchedProducts">
                <button class="btn btn-primary">{{prod}}<fa-icon [icon]="['fas', 'trash']" class="pl-2" (click)="watch(prod, true);"></fa-icon></button>
            </span>
        </div>

        <div class="card-body p-t-1 p-0" *ngIf="viewType === 'list' && (page === 'vulns' || page === 'flagged' || page === 'watched')">
            <app-vuln-list [cves]="vulns" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="vulnsLoaded" (flagEmitter)="flag($event);" (sortEmitter)="sortCVEs($event);"></app-vuln-list>
        </div>

        <div class="card-body p-t-1 p-0" *ngIf="viewType === 'grid' && (page === 'vulns' || page === 'flagged' || page === 'watched')">
            <app-vuln-grid [cves]="vulns" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="vulnsLoaded" (flagEmitter)="flag($event);"></app-vuln-grid>
        </div>

        <div class="card-body justify-content-center p-t-1 p-3" *ngIf="(page === 'vulns' || page === 'flagged') && vulnsLoaded || page === 'watched'">
            <ngb-pagination [collectionSize]="vulnsCount" pageSize="12" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="onPageChange($event)">
                <ng-template ngbPaginationPrevious></ng-template>
                <ng-template ngbPaginationNext></ng-template>
            </ngb-pagination>
        </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>


<ng-template #saveSearch let-modal>
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.saveSearchModal' | translate }}</h4>
            <button type="button" class="cancel" aria-label="cancel" (click)="modal.dismiss('close')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="col-12">
                <label for="reference">{{ 'pages.generic.saveSearchName' | translate }}</label>
                <input type="text" class="form-control" name="searchName" aria-describedby="searchName"  [(ngModel)]="searchName">
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" [disabled]="!searchName" (click)="modal.close('save')">{{ 'pages.generic.save' | translate }}</button>
            <button type="button" class="btn btn-secondary" (click)="modal.close('close')">{{ 'pages.generic.close' | translate }}</button>
        </div>
    </form>
</ng-template>

<ng-template #confirmDeleteSearch let-modal>
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.deleteSearchModal' | translate }}</h4>
            <button type="button" class="cancel" aria-label="cancel" (click)="modal.dismiss('close')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>
                {{ 'pages.generic.deleteSearchConfirm' | translate }}
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary"  (click)="modal.close('delete')">{{ 'pages.generic.confirm' | translate }}</button>
            <button type="button" class="btn btn-secondary" (click)="modal.close('close')">{{ 'pages.generic.close' | translate }}</button>
        </div>
    </form>
</ng-template>